const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/system/integrations/outlook.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/system/integrations/outlook")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Microsoft 365",
      description: "Page title for the Microsoft 365 integration page"
    })
  }
});